<template>
  <main id="contact-info-main">
    <div class="app-view-container">
      <el-row :gutter="20" type="flex" justify="space-between">
        <el-col class="app-view-title">
          {{ $t('account.contactInfo.title') }}
        </el-col>
        <el-col :span="12" class="align-right">
          <name-badge
              v-if="isTab"
              :account-name="customerMasterRecord.accountNameNumber"
              :is-active="customerMasterRecord.accountActive"
          />
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <search-filter-list ref="searchFilterList" @search="onSearch"/>
        </el-col>
      </el-row>

      <el-row class="search-summary-container bg-white">
        <el-col>
          <el-row class="default-section-header">
            <el-col :span="7" class="default-section-title">
              <span >{{ $t('account.contactInfo.summary') }}</span>
              <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('common.refresh')" placement="top-start">
                <el-button @click="handleRefresh" icon="el-icon-refresh" size="mini" class="button-action-default search-summary-refresh-button"></el-button>
              </el-tooltip>
            </el-col>
            <el-col :span="10"  class="default-section-title totals-section">
               <el-row class="default-section-header"></el-row>
            </el-col>
            <el-col :span="7" class="default-section-actions text-align-end">
              <span id="manage-shipment-more-actions-section" v-if="!isProfileView && isEditable">
                <!--<add-minimum @refresh-list="handleRefresh"/>-->
                <add-contact @refresh-list="handleRefresh"/>
              </span>
            </el-col>
          </el-row>
          <el-row class="search-summary">
            <el-col>
              <search-summary-list ref="summaryList" :isEditable="isEditable"/>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </main>
</template>

<script>
import { mapGetters } from 'vuex';
import { ACCOUNT_SEARCH_CONTACT_INFO } from '@/store/actions';
// import constants from '@/utils/constants';
import NameBadge from '@/views/customerCenter/customerMasterRecord/components/nameBadge/NameBadge';
import AddContact from './AddContact';
import SearchFilterList from './SearchFilterList';
import SearchSummaryList from './SearchSummaryList';

export default {
  name: 'Contact-Info',
  components: {
    NameBadge,
    SearchSummaryList,
    SearchFilterList,
    AddContact
  },
  props: {
    isEditable: {
      type: Boolean,
      default: true,
      required: false
    },
    accountId: {
      type: Number,
      default: null,
      required: false
    },
    isTab: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  mounted() {
    this.onSearch();
  },
  computed: {
    ...mapGetters([
      'customerMasterRecord'
    ]),
    isProfileView() {
      return this.customerMasterRecord.isProfileView;
    }
  },
  data() {
    return {
      selectedRow: null,
      accountReady: false
    };
  },
  methods: {
    handleRefresh() {
      this.onSearch();
    },
    onSearch() {
      const { id } = this.accountId || this.customerMasterRecord.list[0];
      this.$store.dispatch(ACCOUNT_SEARCH_CONTACT_INFO, { accountId: id });
    },
    handleSearch() {
      this.onSearch();
    },
    setConsignee(accountId) {
      if (this.$refs.searchFilterList && this.$refs.searchFilterList.searchForm) {
        this.$refs.searchFilterList.searchForm.consigneeId = accountId;
        this.$refs.searchFilterList.handleSearch();
      }
    }
  }
};
</script>
<style scoped>
.align-right {
  justify-content: flex-end; /* Fuerza el contenido al extremo derecho */
  text-align: right;        /* Backup para navegadores antiguos [cite: 17] */
}
</style>
